// extracted by mini-css-extract-plugin
export var configurationSection = "_ri-0";